export class StudentLinksModel {
	id: string;
	type: string;
	title: string;
	link: string;
}
